module.exports = __webpack_public_path__ + "static/media/23.bf7e7aa0.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/23.JPG
// module id = 466
// module chunks = 0